import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { BookOpen, Plus } from 'lucide-react';
import Button from '@/components/primitives/Button.jsx';
import EmptyState from '@/components/patterns/EmptyState.jsx';
import PageHeader from '@/components/patterns/PageHeader.jsx';
import RowList from '@/components/patterns/RowList.jsx';
import describeKnowledgeFile from '@/lib/knowledge/describeKnowledgeFile.js';
import formatUpdatedOn from '@/lib/knowledge/formatUpdatedOn.js';
import { knowledgeFiles } from '@/redux/selectors/pieveSelectors/knowledgeFileSelectors.js';

/** The organization's notes Pieve reads when it works: policies, product facts, how the team works. */
const KnowledgePage = () => {
  const navigate = useNavigate();
  const files = useSelector(knowledgeFiles);
  const newDocument = (
    <Button variant="primary" iconStart={Plus} onClick={() => navigate('/knowledge/new')}>
      New document
    </Button>
  );

  return (
    <div className="comp-page">
      <PageHeader title="Knowledge" description="What Pieve knows about your company: policies, product facts and how your team works." actions={files.length > 0 ? newDocument : null} />
      {files.length === 0 ? (
        <EmptyState icon={BookOpen} title="Nothing here yet" description="Write down what Pieve should know about your company, such as your refund policy or who handles which customers." action={newDocument} />
      ) : (
        <RowList
          label="Knowledge documents"
          items={files.map((file) => {
            const name = file.path.slice('organization/'.length);
            return { id: file.path, to: `/knowledge/${encodeURIComponent(name)}`, title: describeKnowledgeFile({ path: file.path }), note: formatUpdatedOn(file.updatedOn) };
          })}
        />
      )}
    </div>
  );
};

export default KnowledgePage;
